module.exports = __webpack_public_path__ + "static/media/mw.3a771f57.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mw.svg
// module id = 724
// module chunks = 0